module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAAAAABWESUoAAAAEklEQVQ4T2NgGAWjYBSMAuwAAAQgAAGfPyHBAAAAAElFTkSuQmCC"